<div class="main-container" @fadeIn>
	<form class="main-form" [formGroup]="binderFormGroup">
		<app-loader [isInline]="true" *ngIf="isLoading" [hasTransparency]="true"
					[loaderMessage]="''"></app-loader>
		<!-- <div class="location-wrapper">
			<div class="location-label">Current Location:</div>
			<div [ngClass]="currentLocation.name === 'undetermined' ? 'undetermined' : 'address-label'">{{currentLocation.name}}</div>
		</div> -->
		<div class="site-address-container">
			<div>Site address:</div>
			<div class="site-address-wrapper">
				<div class="site-address">
					<div *ngIf="binderFormGroup.get('address').value; else noAddressTemplate">
						<div>{{selectedAddress?.line1}}</div>
						<div>{{selectedAddress?.city}}<span *ngIf="selectedAddress?.code2">,
								{{selectedAddress.code2}}</span><span *ngIf="selectedAddress?.zipCode">,
								{{selectedAddress.zipCode}}</span></div>
					</div>
					<ng-template #noAddressTemplate>
						<div class="no-address-placeholder">Please use lookup to select a site address</div>
					</ng-template>
				</div>
				<div class="address-lookup">
					<button mat-flat-button color="primary" (click)="onLookup()">Find Site</button>
				</div>
			</div>
		</div>
		<div class="form-item-group">
			<div *ngIf="!isLoading && binderFormGroup.get('binder').disabled" class="binder-info-message no-option">No Binders available for the above location</div>
			<mat-form-field [ngClass]="{'binder-dropdown-disabled': binderFormGroup.get('binder').disabled}">
				<mat-label>Select a Binder</mat-label>
				<mat-select formControlName="binder">
					<mat-option class="binder-select-option" *ngFor="let b of binders" [value]="b">
						<div class="binder-name">{{b.binderName}}</div>
						<div class="binder-asset">{{b.accountSiteResourceName}}</div>
						<div class="binder-account">{{b.accountName}}</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="form-item-group">
			<mat-form-field>
				<mat-label>Email</mat-label>
				<input matInput formControlName="email">
			</mat-form-field>
		</div>
		<div class="work-to-do-container">
			<mat-checkbox formControlName="hasWorkToDo">
				<div class="primary-message">I have work to do</div>
				<div class="message">(only granted to verified accounts)</div>
			</mat-checkbox>
		</div>
		<div class="form-submit-container">
			<button mat-flat-button color="primary" [disabled]="binderFormGroup.invalid || !binderFormGroup.get('binder').value"
				(click)="onSubmit()">Submit</button>
		</div>
	</form>
</div>

<generic-modal #lookupModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading>
		<div class="header-wrapper">
			<div class="header-title">
				<h3>Find Site</h3>
			</div>
		</div>
	</ng-template>
	<ng-template #modalBody>
		<form class="main-form lookup-address-form" [formGroup]="lookupAddressFormGroup">
			<mat-form-field class="search-address-wrapper">
				<mat-label>Search</mat-label>
				<input type="text" matInput formControlName="search" [matAutocomplete]="auto">
				<button mat-button *ngIf="lookupAddressFormGroup.get('search')?.value" matSuffix mat-icon-button aria-label="Clear"
					(click)="onClearAddress()">
					<mat-icon>close</mat-icon>
				</button>
				<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getAddressLabel">
					<mat-option class="binder-select-option" *ngFor="let a of addressPredictions$ | async" [value]="a">
						<div>{{a.line1}}</div>
						<div>{{a.details}}</div>
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
			
			<div class="address-container">
				<div class="address-label">Site addresses at your location:</div>
				<div class="address-list-wrapper">
					<ng-container *ngIf="siteAddresses$ | async as siteAddresses; else addresses_loading" #not_loading>
						<ng-container *ngIf="siteAddresses.length; else empty_template">
							<mat-selection-list class="site-addresses-list" [multiple]="false" formControlName="address"
								hideSingleSelectionIndicator="true" *ngIf="siteAddresses.length">
								<mat-list-option *ngFor="let item of siteAddresses" [value]="item">
									<div class="site-address-wrapper">
										<div class="site-address-info">
											<div>{{item.line1}}</div>
											<div>{{item.city}} {{item.code2}} {{item.zipCode}}</div>
										</div>
										<div class="distance-info">
											({{item.distance | number : '1.2-2'}} mi)
										</div>
									</div>
								</mat-list-option>
							</mat-selection-list>
						</ng-container>
						<ng-template #empty_template>
							<div class="no-address-message">
								No site address found.
							</div>
						</ng-template>
					</ng-container>
					<ng-template #addresses_loading>
						<mat-spinner diameter="60"></mat-spinner>
					</ng-template>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button class="primary" [disabled]="!isAnyAddressSelected()"
			(click)="onChooseAddress()">Ok</button>
		<button mat-flat-button (click)="onCloseLookup()">Cancel</button>
	</ng-template>
</generic-modal>